import React, { useRef, useCallback, useEffect, useState } from "react";
import { GoogleMap, useLoadScript, Marker, Polyline } from "@react-google-maps/api";
import { mapContainerStyle, defaultZoom } from "constants/agent-tracking";
import { useTranslation } from "react-i18next";
import { GOOGLE_MAPS_API_KEY } from "constants/config";
import { configService } from "services/configService";

export const AgentTrackingMap = ({ data }) => {
    const { t } = useTranslation();

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    });

    const mapRef = useRef(null);
    const onMapLoad = useCallback((map) => {
        mapRef.current = map;
    }, []);

    const [defaultCenter, setDefaultCenter] = useState(null);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const config = await configService.get();
                if (config.lat && config.lng) {
                    setDefaultCenter({
                        lat: parseFloat(config.lat),
                        lng: parseFloat(config.lng),
                    });
                }
            } catch (err) {
                showToast({ title: t(err.message), status: "error" });
            }
        };

        fetchConfig();
    }, []);

    const isDataValid = Array.isArray(data) && data.length > 0;

    const routePath = isDataValid
        ? data.map((d) => ({
            lat: d.latitude,
            lng: d.longitude,
        }))
        : [];

    const center = routePath[0] || defaultCenter;

    return (
        <>
            {loadError && (
                <div>{t("reports.agent-tracking.messages.errors.load-error")}</div>
            )}

            {!loadError && !isLoaded && !defaultCenter && (
                <div>{t("reports.agent-tracking.messages.loading-map")}</div>
            )}

            {!loadError && isLoaded && (
                <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    zoom={defaultZoom}
                    center={center}
                    onLoad={onMapLoad}
                >
                    {isDataValid &&
                        data.map((point, index) => {
                            const position = {
                                lat: point.latitude,
                                lng: point.longitude,
                            };

                            return (
                                <Marker
                                    key={index}
                                    position={position}
                                    label={{
                                        text: `${index + 1} - ${point.data.split(' ')[1]}`,
                                        fontWeight: "bold",
                                    }}
                                />
                            );
                        })}

                    {routePath.length > 1 && (
                        <Polyline
                            path={routePath}
                            options={{
                                strokeColor: "#FF0000",
                                strokeOpacity: 1.0,
                                strokeWeight: 2,
                            }}
                        />
                    )}
                </GoogleMap>
            )}
        </>
    );
};
